module.exports = [
    {
        "title": "地方金融监管部门的备案信息",
        "contents": [
            {
                "text": "备案登记地方金融监管部门：待验收"
            },
            {
                "text": "备案登记时间：待验收"
            },
            {
                "text": "备案登记编号：待验收"
            }
        ]
    },
    {
        "title": "电信业务经营许可",
        "contents": [
            {
                "text": "电信业务经营许可证号：京ICP证151153号"
            }
        ]
    },
    {
        "title": "资金存管",
        "contents": [
            {
                "text": "资金存管银行：新网银行"
            },
            {
                "text": "资金存管上线时间：2018年11月23日"
            }
        ]
    },
    {
        "title": "网站备案",
        "contents": [
            {
                "link": "京公网安备11010502033643号",
                "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033643"
            }
        ]
    },
    {
        "title": "信息安全测评认证信息",
        "contents": [
            {
                "text": "三级等保",
                "link": "点击查看",
                "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E7%AD%89%E4%BF%9D%E4%B8%89%E7%BA%A7%E5%A4%87%E6%A1%88%E8%AF%81%E6%98%8E.pdf"
            }
        ]
    },
    {
        "title": "风险管理",
        "contents": [
            {
                "text": "风险管理架构",
            },
            {
                "imgText": "风险管理架构",
                "imgSrc": "//j1.58cdn.com.cn/jinrong/licai/pc/riskframe_pc.png"
            },
            {
                "text": "风险评估流程",
                "link": "点击查看",
                "href": "//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E9%A3%8E%E9%99%A9%E8%AF%84%E4%BC%B0%E6%B5%81%E7%A8%8B.pdf"
            },
            {
                "text": "风险预警管理情况",
                "subTexts": [
                    "58钱柜对借款项目进行了科学的风险评估，并在平台上进行了充分的风险提示。同时，58钱柜也将按照监管要求对项目信息和借款人信息及时进行披露。"
                ]
            },
            {
                "text": "催收方式",
                "subTexts": [
                    "58钱柜通针对催收业务制订了严格的管理制度，配备有一整套催收管理系统，结合催收模型评分对于入催时间、强度、客户分类、回收目标等均严格要求，催收以电催为主，也会采取诉讼、短信等辅助手段；注重文明催收，电话号码管理，短信内容，话术上都有非常严格的规定；若与外包公司合作进行联合催收的，外包公司必须遵守58钱柜的相关催收管理制度。"
                ]
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/InfoDcs/Record.js